<template>
  <v-container v-if="selectedChild.examRegistrations">
    <v-row>
      <v-col v-if="isAdmin" col="8">
        <v-select
          :items="schoolYears"
          item-text="description"
          item-value="id"
          label="Exam Registration for School Year"
          v-model="schoolYearSelected"
          return-object
        ></v-select>
      </v-col>
      <v-col v-else cols="8">
        <p class="title">Exam Registration for {{schoolYearSelected.description}}</p>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <AccountCreditChip />
      </v-col>
    </v-row>
    <v-row v-if="account">
      <v-select
        v-if="account.children"
        :items="account.children"
        label="Child"
        v-model="selectedChild"
      >
        <template v-slot:item="child">
          <v-chip
            label
            outlined
            :color="child.item.color"
            class="font-weight-bold ma-2"
          >{{ child.item.id }}</v-chip>

          <v-avatar :color="child.item.color" size="36" class="ma-2">
            <span class="white--text">
              <strong>{{ child.item.chipInitials }}</strong>
            </span>
          </v-avatar>
          {{ child.item.childFirstName }} {{ child.item.childLastName }}
        </template>
        <template v-slot:selection="child">
          <v-chip
            label
            outlined
            :color="child.item.color"
            class="font-weight-bold ma-2"
          >{{ child.item.id }}</v-chip>

          <v-avatar :color="child.item.color" size="36" class="ma-2">
            <span class="white--text">
              <strong>{{ child.item.chipInitials }}</strong>
            </span>
          </v-avatar>
          {{ child.item.childFirstName }} {{ child.item.childLastName }}
        </template>
      </v-select>
      <v-spacer></v-spacer>
      <ReturnHomeBtn />
      <CheckOutBtn />
    </v-row>
    <v-row v-for="subject in subjects" :key="subject.id" align="center" justify="start">
      <v-col cols="2">
        <span class="subtitle-2">{{ subject.description }}</span>
      </v-col>
      <v-col cols="10">
        <v-row dense align="center">
          <v-col v-for="er in getButtons(subject.id)" :key="er.id" cols="3">
            <v-chip
              :color="
                er.isDistinction
                  ? 'light-green'
                  : er.label !== 'In the cart'
                  ? 'green'
                  : 'primary'
              "
              label
              large
              outlined
              class="text-center"
            >
              <v-avatar left>
                <v-icon v-if="er.label === 'In the cart'">mdi-cart</v-icon>
                <span v-if="er.label !== 'In the cart'">
                  <v-icon
                    v-if="!er.isDistinction && er.label !== 'Registered'"
                  >mdi-checkbox-marked-circle</v-icon>
                  <v-icon v-if="!er.isDistinction && er.label === 'Registered'">mdi-calendar-check</v-icon>
                  <v-icon v-if="er.isDistinction">mdi-star</v-icon>
                </span>
              </v-avatar>
              Grade {{ er.gradeLevel }}
              <br />
              {{ er.label }}
            </v-chip>
          </v-col>
          <v-col
            cols="1"
            v-if="subjectGradeLevel[subject.id - 1] <= 7 && 
              (subjectGradeIsOpen[subject.id -1] || (isAdmin && !schoolYearSelected.isTheoreticalExamsOnly)) && 
              !(subjectGradeLevel[subject.id - 1] === 1 && schoolYearSelected.isTheoreticalExamsOnly)"
          >
            <v-btn
              large
              color="success"
              @click.stop="
                showDialog(
                  subject.id,
                  subjectGradeLevel[subject.id - 1],
                  subjectGradeIsRetry[subject.id - 1]
                )
              "
            >
              <v-icon left>mdi-calendar-check</v-icon>
              Grade {{ subjectGradeLevel[subject.id - 1] }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent class="mx-auto" max-width="600">
      <v-form ref="form">
        <v-card outlined>
          <v-card-title>
            Register {{ selectedChild.childFirstName }}
            {{ selectedChild.childLastName }}
            <br />
            for
            {{ getSubjectDescription( registrationModel.subjectId ) }} Grade
            {{ registrationModel.gradeLevel }} {{ schoolYearSelected.description }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="selectedTeacher"
                  :items="teachers.filter(t => t.isActive)"
                  label="Select teacher"
                  :rules="[v => !!v.id || 'Teacher is required']"
                  :filter="teacherFilter"
                  required
                  return-object
                >
                  <template v-slot:item="teacher">
                    {{ teacher.item.firstName }}
                    {{ teacher.item.lastName }}
                  </template>
                  <template v-slot:selection="teacher">
                    {{ teacher.item.firstName }}
                    {{ teacher.item.lastName }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" v-if="registrationModel.isRetry">
                <v-card class="px-2 py-1" outlined>
                  <v-card-title>Exam Type</v-card-title>
                  <v-card-text>
                    <v-radio-group :mandatory="true" v-model="examType" row class="justify-center">
                      <v-radio label="Comprehensive" value="comprehensive"></v-radio>
                      <v-radio label="Retry*" value="retry"></v-radio>
                    </v-radio-group>* "Ordinary Pass" is the maximum grade for Retry exam type.
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>-->
            <v-row>
              <v-col>
                <p class="headline text-right">
                  Registration fee is ${{
                  getExamFee(
                  registrationModel.gradeLevel,
                  examType === "retry"
                  )
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-if="
                examFee &&
                  Number(new Date()) > Number(new Date(schoolYearSelected.lateFeeDate))
              "
              >Registration amount includes ${{ lateFee }} late fee.</v-col>
              <v-col v-else>
                Registrations after {{ schoolYearSelected.lateFeeDate | formatDate }} will
                incur a ${{ lateFee }} late fee.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close">Cancel</v-btn>
            <v-btn class="mx-4 my-2" color="primary" @click="submit">Add to Cart</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { errorMessageMixin, subjectMixin, lateFeeMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";
import CheckOutBtn from "../components/CheckOutBtn.vue";
import AccountCreditChip from "../components/AccountCreditChip.vue";

export default {
  name: "ExamRegistration",
  props: {
    childId: {
      type: Number,
      default: 0
    }
  },
  mixins: [errorMessageMixin, subjectMixin, lateFeeMixin],
  data() {
    return {
      selectedChild: {},
      subjectGradeLevel: [],
      subjectGradeIsRetry: [],
      subjectGradeIsOpen: [],
      dialog: false,
      registrationModel: {},
      selectedTeacher: {},
      examType: "comprehensive",
      schoolYearSelected: {}
    };
  },
  components: { ReturnHomeBtn, CheckOutBtn, AccountCreditChip },
  computed: {
    ...mapState([
      "account",
      "subjects",
      "teachers",
      "examFees",
      "schoolYear",
      "schoolYears"
    ]),
    ...mapGetters(["isAdmin"]),
    items: function() {
      return this.$store.state.account.children.map(
        c => c.childFirstName + " " + c.childLastName
      );
    },
    examFee: function() {
      let result = null;
      if (this.$store.state.examFees) {
        result = this.$store.state.examFees.find(
          e => e.gradeLevel === this.registrationModel.gradeLevel
        );
      }
      return result;
    },
    lateFee: function() {
      let result = null;
      if (this.$store.state.examFees) {
        result = this.$store.state.examFees.find(
          e => e.gradeLevel === this.registrationModel.gradeLevel
        );
      }
      if (result) {
        return result.lateFee;
      }
      return 0;
    }
  },
  async created() {
    console.log("this.childId", this.childId);
    if (this.schoolYear) {
      this.schoolYearSelected = this.schoolYear;
    } else {
      await this.loadSchoolYears();
      this.schoolYearSelected = this.schoolYears[0];
    }
    if (this.childId === 0) {
      this.selectedChild = this.$store.state.account.children[0];
    } else {
      this.selectedChild = this.$store.state.account.children.find(
        ({ id }) => id === this.childId
      );
      console.log("this.selectedChild", this.selectedChild);
      if (this.selectedChild == null) {
        console.log("unauthorized to view this child");
        this.$router.push({ name: "Home", params: { msg: "authorized." } });
        return;
      }
    }
    this.selectedChild.examRegistrations.sort(function(a, b) {
      if (a.gradeLevel < b.gradeLevel) {
        return -1;
      }
      if (a.gradeLevel > b.gradeLevel) {
        return 1;
      }
      return a.createdDate - b.createdDate;
    });
    this.$store.state.subjects.forEach(element => {
      console.log(element);
      this.subjectGradeLevel.push(1);
      this.subjectGradeIsRetry.push(false);
      this.subjectGradeIsOpen.push(
        !this.schoolYearSelected.isTheoreticalExamsOnly
      );
    });
  },
  watch: {
    selectedChild: function(newValue, oldValue) {
      if (oldValue.id != null) {
        // make sure to only reset if the oldvalue is valid.
        for (var i = 0; i < this.subjectGradeLevel.length; i++) {
          this.subjectGradeLevel[i] = 1;
          this.subjectGradeIsRetry[i] = false;
          this.subjectGradeIsOpen[i] = !this.schoolYearSelected
            .isTheoreticalExamsOnly;
        }
      }
    },
    schoolYearSelected: async function(val) {
      this.setSchoolYearAction(val);
      console.log("im in the watch for schoolYear", this.schoolYear);
    }
  },
  methods: {
    ...mapActions([
      "addExamRegistrationAction",
      "getSchoolYearsAction",
      "setSchoolYearAction"
    ]),

    teacherFilter(item, queryText) {
      console.log("filter item", item);
      const firstName = (item.firstName ?? "").toLowerCase();
      const lastName = (item.lastName ?? "").toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        firstName.indexOf(searchText) > -1 || lastName.indexOf(searchText) > -1
      );
    },

    getButtons(subjectId) {
      let buttons = [];
      let data = this.selectedChild.examRegistrations.filter(
        e => e.subjectId === subjectId && e.examGradeType !== 6
      );
      data = this.uniqByKeepLast(data, d => d.gradeLevel);
      data.forEach(d => {
        if (!d.isPaid) {
          // in the cart
          buttons.push({
            gradeLevel: d.gradeLevel,
            label: "In the cart",
            isDistinction: false
          });
          this.subjectGradeLevel[subjectId - 1] = d.gradeLevel + 1;
          this.subjectGradeIsRetry[subjectId - 1] = false;
          this.subjectGradeIsOpen[subjectId - 1] = false;
        } else if (d.examGradeType === 0) {
          // registered for class
          buttons.push({
            gradeLevel: d.gradeLevel,
            label: "Registered",
            isDistinction: false
          });
          this.subjectGradeLevel[subjectId - 1] = d.gradeLevel + 1;
          this.subjectGradeIsRetry[subjectId - 1] = false;
          this.subjectGradeIsOpen[subjectId - 1] = false;
        } else if (d.examGradeType <= 4) {
          // 1:distinction, 2:1st division, 3:2nd division, 4:ordinary pass
          buttons.push({
            gradeLevel: d.gradeLevel,
            label: "Completed",
            isDistinction: d.examGradeType === 1
          });
          this.subjectGradeLevel[subjectId - 1] = d.gradeLevel + 1;
          this.subjectGradeIsRetry[subjectId - 1] = false;
          this.subjectGradeIsOpen[subjectId - 1] = !this.schoolYearSelected
            .isTheoreticalExamsOnly;
        } else {
          // class is retryable
          console.log(
            "in buttons retry",
            this.schoolYearSelected.isTheoreticalExamsOnly
          );
          this.subjectGradeIsRetry[
            subjectId - 1
          ] = this.schoolYearSelected.isTheoreticalExamsOnly;
          this.subjectGradeIsOpen[subjectId - 1] = true;
        }
      });
      return buttons;
    },
    uniqByKeepLast(a, key) {
      // https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
      return [...new Map(a.map(x => [key(x), x])).values()];
    },
    close() {
      this.dialog = false;
    },
    showDialog(subjectId, gradeLevel, isRetry) {
      console.log(
        "showdialog subjectId, gradeLevel",
        subjectId,
        gradeLevel,
        isRetry
      );
      this.setRegistrationModel(subjectId, gradeLevel, isRetry);
      this.selectedTeacher = {};
      this.examType = isRetry ? "retry" : "comprehensive";
      this.dialog = true;
    },
    setRegistrationModel(subjectId, gradeLevel, isRetry) {
      this.registrationModel = {
        subjectId: subjectId,
        gradeLevel: gradeLevel,
        isRetry: isRetry
      };
    },
    async submit() {
      if (this.$refs.form.validate()) {
        console.log(
          "im valid. admin needs to be able to modify the schoolyear"
        );
        let addExamRegistrationModel = {
          accountId: this.account.id,
          childId: this.selectedChild.id,
          schoolYearId: this.schoolYearSelected.id,
          subjectId: this.registrationModel.subjectId,
          gradeLevel: this.registrationModel.gradeLevel,
          teacherId: this.selectedTeacher.id,
          feeAmount: 0,
          isPaid: false,
          examGradeType: 0,
          isRetry: this.examType === "retry"
        };
        console.log("addExamRegistrationModel", addExamRegistrationModel);
        try {
          await this.addExamRegistrationAction({
            model: addExamRegistrationModel,
            token: this.$store.state.token
          });
          this.close();

          this.$store.state.error =
            "Exam registration added to cart. Refreshing screen...";
          this.$store.state.snackbarColor = "success";
          this.$store.state.snackbar = true;

          this.$router
            .replace(`/examregistration/${this.selectedChild.id}`)
            .catch(err => {
              if (err.name != "NavigationDuplicated") {
                throw err;
              }
            });

          this.$router.go(); // needed to "refresh" and display newly added cert item
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        return;
      }
    },
    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    }
  }
};
</script>
